import {Queue, createLoader} from './media/loaders';

var _currentLocale = "en";
var _supportedLanguages = ["en"];
var _strings = {};
var _path = "assets/language";
var _iniPrefix = "";
var _iniExt = "csv";
var _iniSeparator = ";";
var _parser = null;

/**
 * @class
 * @description Класс локализации
 */
class I18 {

	/** текущая локаль */
    static get currentLocale() {
        return _currentLocale;
    }
    static set currentLocale(val) {
        _currentLocale = val;
    }

    /** массив поддерживаемых локалей */
    static get supportedLanguages() {
        return _supportedLanguages;
    }
    static set supportedLanguages(val) {
        _supportedLanguages = val;
    }

    /** хеш ключ-значение */
    static get strings() {
        return _strings;
    }
    static set strings(val) {
        _strings = val;
    }

    /** папка с файлами локализаций */
    static get path() {
        return _path;
    }
    static set path(val) {
        _path = val;
    }

    /** префикс файлов локализаций */
    static get iniPrefix() {
        return _iniPrefix;
    }
    static set iniPrefix(val) {
        _iniPrefix = val;
    }
    /** расширение файлов локализаций */
    static get iniExt() {
        return _iniExt;
    }
    static set iniExt(val) {
        _iniExt = val;
    }

    /** разделитель ключ-значение в файле локализации */
    static get iniSeparator() {
        return _iniSeparator;
    }
    static set iniSeparator(val) {
        _iniSeparator = val;
    }

    /** кастомный парсер файла локализации, если формат отличен от дефолтного ключ[разделитель]значение */
    static get parser() {
        return _parser;
    }
    static set parser(val) {
        _parser = val;
    }

    /**
     * @description Инициализация
     * @param {String} [locale=null] локаль. Если null, локаль будет пытаться определиться автоматически
     */
    static init(locale=null, path = 'assets/language') {
      _path = path;
	    var lang = window.navigator.userLanguage || window.navigator.language || "";
		if (!locale) locale = lang.substr(0, 2);
	    if(I18.supportedLanguages.indexOf(locale) < 0) locale = I18.supportedLanguages[0];

	    I18.currentLocale = locale;
	}

    static parse(data) {
        var strings = {};

        if(I18.parser) {
            strings = I18.parser(data);
        }
        else {
            let parts = data.split("\n"), keyVal;

            for(let part of parts) {
                keyVal = part.split(I18.iniSeparator);
                if(keyVal[0].trim()) strings[keyVal[0].trim()] = keyVal[1].trim();
            }
        }

        return strings;
    }

    static createLoaderQueue() {
        let queue = new Queue();
        let loader = createLoader(I18.path + "/" + I18.iniPrefix + I18.currentLocale + "." + I18.iniExt + "?v=" + (new Date().getTime()), this.context);
        queue.add(loader);

        queue.on('fileload', (e) => {
            I18.setup(I18.parse(e.item.data));
        });

        return queue;
    }

    static load(callback) {
        let queue = I18.createLoaderQueue();
        queue.on('fileload', callback);
        queue.load();
    }

	/** @ignore */
    static setup(data) {
		I18.strings = data;
	}

    /** @ignore */
    static trim(s) {
	    return s.trim();
	}

    /** @ignore */
    static arrayAntidot(values) {
        if (!values) return;
        if (values.length > 0 && Array.isArray(values[0])) return values[0];
        return values;
    }

    /** @ignore */
    static getString(key, values) {
		if (typeof values == "undefined") values = null;

		var str = I18.getStringOrNull(key, values);
		if (str == null) return "{" + key + "}";

		return str;
	}

    /** @ignore */
    static getStringOrNull(key, args)
	{
		if (typeof args == "undefined") args = null;

		var value = I18.strings[key];
		if (typeof value == "undefined") value = null;

		if(args == null || value == null) return value;
		else {
		    args = [value].concat(I18.arrayAntidot(args));
		    return I18.sprintf.apply(I18, args);
		}
	}

    /**
     * @description Получение значения по ключу и параметрам
     * @param {String} key ключ
     * @param ... произвольные параметры
     * @returns {String}
     */
    static f(key, ...values) {
		return I18.getString(key, values);
	}

    /**
     * @description Получение значения по префиксу и ключу
     * @param {String} prefix префикс
     * @param {String} key ключ
     * @param {Array} [values=null] массив значений
     * @returns {String}
     */
    static s(prefix, key, values) {
		if (!Array.isArray(values)) values = [values];
		return I18.getString(prefix + "_" + key, I18.arrayAntidot(values));
	}

    /**
     * @description Получение значения по суфиксу и ключу
     * @param {String} key ключ
     * @param {String} suffix суфикс
     * @param {Array} [values=null] массив значений
     * @returns {String}
     */
    static sf(key, suffix, values) {
		return I18.getString(key + "_" + suffix, I18.arrayAntidot(values));
	}

    /**
     * @description Получение значения по префиксу, суфиксу и ключу
     * @param {String} prefix префикс
     * @param {String} key ключ
     * @param {String} suffix суфикс
     * @param {Array} [values=null] массив значений
     * @returns {String}
     */
    static psf(prefix, key, suffix, values)	{
		return I18.getString(prefix + "_" + key + "_" + suffix, I18.arrayAntidot(values));
	}

    /** @ignore */
    static sprintf(...values) {
        var regex = /%%|%(\d+\$)?([-+\'#0 ]*)(\*\d+\$|\*|\d+)?(\.(\*\d+\$|\*|\d+))?([scboxXuideEfFgG])/g;
        var a = values;
        var i = 0;
        var format = a[i++];

        var pad = function(str, len, chr, leftJustify)
        {
            if (!chr) chr = ' ';
            var padding = (str.length >= len) ? '' : new Array(1 + len - str.length >>> 0).join(chr);
            return leftJustify ? str + padding : padding + str;
        };

        var justify = function(value, prefix, leftJustify, minWidth, zeroPad, customPadChar)
        {
            var diff = minWidth - value.length;
            if (diff > 0)
            {
                if (leftJustify || !zeroPad) value = pad(value, minWidth, customPadChar, leftJustify);
                else value = value.slice(0, prefix.length) + pad('', diff, '0', true) + value.slice(prefix.length);
            }
            return value;
        };

        var formatBaseX = function(value, base, prefix, leftJustify, minWidth, precision, zeroPad)
        {
            var number = value >>> 0;
            prefix = prefix && number && {'2': '0b', '8': '0', '16': '0x'}[base] || '';
            value = prefix + pad(number.toString(base), precision || 0, '0', false);
            return justify(value, prefix, leftJustify, minWidth, zeroPad);
        };

        var formatString = function(value, leftJustify, minWidth, precision, zeroPad, customPadChar)
        {
            if (precision != null) value = value.slice(0, precision);
            return justify(value, '', leftJustify, minWidth, zeroPad, customPadChar);
        };

        var doFormat = function(substring, valueIndex, flags, minWidth, _, precision, type)
        {
            var number, prefix, method, textTransform, value;

            if (substring === '%%') return '%';

            var leftJustify = false;
            var positivePrefix = '';
            var zeroPad = false;
            var prefixBaseX = false;
            var customPadChar = ' ';
            var flagsl = flags.length;
            for (var j = 0; flags && j < flagsl; j++)
            {
                switch (flags.charAt(j))
                {
                    case ' ':
                        positivePrefix = ' ';
                        break;
                    case '+':
                        positivePrefix = '+';
                        break;
                    case '-':
                        leftJustify = true;
                        break;
                    case "'":
                        customPadChar = flags.charAt(j + 1);
                        break;
                    case '0':
                        zeroPad = true;
                        customPadChar = '0';
                        break;
                    case '#':
                        prefixBaseX = true;
                        break;
                }
            }

            if (!minWidth) minWidth = 0;
            else if (minWidth === '*') minWidth = +a[i++];
            else if (minWidth.charAt(0) == '*') minWidth = +a[minWidth.slice(1, -1)];
            else minWidth = +minWidth;

            if (minWidth < 0)
            {
                minWidth = -minWidth;
                leftJustify = true;
            }

            if (!isFinite(minWidth))
            {
                throw new Error('sprintf: (minimum-)width must be finite');
            }

            if (!precision) precision = 'fFeE'.indexOf(type) > -1 ? 6 : (type === 'd') ? 0 : undefined;
            else if (precision === '*') precision = +a[i++];
            else if (precision.charAt(0) == '*') precision = +a[precision.slice(1, -1)];
            else  precision = +precision;

            value = valueIndex ? a[valueIndex.slice(0, -1)] : a[i++];

            switch (type)
            {
                case 's':
                    return formatString(String(value), leftJustify, minWidth, precision, zeroPad, customPadChar);
                case 'c':
                    return formatString(String.fromCharCode(+value), leftJustify, minWidth, precision, zeroPad);
                case 'b':
                    return formatBaseX(value, 2, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
                case 'o':
                    return formatBaseX(value, 8, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
                case 'x':
                    return formatBaseX(value, 16, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
                case 'X':
                    return formatBaseX(value, 16, prefixBaseX, leftJustify, minWidth, precision, zeroPad).toUpperCase();
                case 'u':
                    return formatBaseX(value, 10, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
                case 'i':
                case 'd':
                    number = +value || 0;
                    number = Math.round(number - number % 1);
                    prefix = number < 0 ? '-' : positivePrefix;
                    value = prefix + pad(String(Math.abs(number)), precision, '0', false);
                    return justify(value, prefix, leftJustify, minWidth, zeroPad);
                case 'e':
                case 'E':
                case 'f':
                case 'F':
                case 'g':
                case 'G':
                    number = +value;
                    prefix = number < 0 ? '-' : positivePrefix;
                    method = ['toExponential', 'toFixed', 'toPrecision']['efg'.indexOf(type.toLowerCase())];
                    textTransform = ['toString', 'toUpperCase']['eEfFgG'.indexOf(type) % 2];
                    value = prefix + Math.abs(number)[method](precision);
                    return justify(value, prefix, leftJustify, minWidth, zeroPad)[textTransform]();
                default:
                    return substring;
            }
        };

        return format.replace(regex, doFormat);
    }
}

export default I18;
